import { render, staticRenderFns } from "./designerDialog.vue?vue&type=template&id=71f012e7&scoped=true&"
import script from "./designerDialog.vue?vue&type=script&lang=js&"
export * from "./designerDialog.vue?vue&type=script&lang=js&"
import style0 from "./designerDialog.vue?vue&type=style&index=0&id=71f012e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f012e7",
  null
  
)

export default component.exports